import { Participant } from "../models/Participant";
import { VisitationRotationBlock } from "../models/VisitationRotationBlock";
import { VisitationScheduleInterval } from "../models/VisitationScheduleInterval";
import { VisitationScheduleType } from "../models/VisitationScheduleType";

export function generateRotationBlocks(
  rotation: { [key: number]: VisitationRotationBlock },
  type: VisitationScheduleType,
  participants: Participant[],
  interval: VisitationScheduleInterval,
  flip: boolean = false,
): { [key: number]: VisitationRotationBlock } {
  const weeks = parseInt(interval.split("-")[0]);
  const daysToRender = weeks * 7;
  const results: { [key: number]: VisitationRotationBlock } = {};

  const [a, b] = participants;
  if (!a || !b) return results;

  let basePattern: Participant[] = [];

  switch (type) {
    case "2-2-3": {
      // 2-2-3 is a 7-day pattern, alternating every week
      const weekPattern = [a, a, b, b, a, a, a]; // Week 1
      const altWeekPattern = [b, b, a, a, b, b, b]; // Week 2
      for (let i = 0; i < weeks; i++) {
        basePattern.push(...(i % 2 === 0 ? weekPattern : altWeekPattern));
      }
      break;
    }
    case "2-2-5-5": {
      const pattern = [a, a, b, b, a, a, a, a, a, b, b, b, b, b]; // 14-day pattern
      for (let i = 0; i < daysToRender; i++) {
        basePattern.push(pattern[i % pattern.length]);
      }
      break;
    }
    case "3-3-4-4": {
      const pattern = [a, a, a, b, b, b, a, a, a, a, b, b, b, b]; // 14-day pattern
      for (let i = 0; i < daysToRender; i++) {
        basePattern.push(pattern[i % pattern.length]);
      }
      break;
    }
    case "alternating_weekends": {
      for (let i = 0; i < daysToRender; i++) {
        const week = Math.floor(i / 7);
        const day = i % 7;
        const isWeekend = day === 5 || day === 6;
        const assignTo =
          week % 2 === 0 ? (isWeekend ? b : a) : isWeekend ? a : b;
        basePattern.push(assignTo);
      }
      break;
    }
    case "5th_weekend": {
      for (let i = 0; i < daysToRender; i++) {
        const week = Math.floor(i / 7) + 1;
        const day = i % 7;
        const isWeekend = day === 5 || day === 6;
        const assignTo = isWeekend && week % 5 === 0 ? b : a;
        basePattern.push(assignTo);
      }
      break;
    }
    case "custom":
      return { ...rotation };
    default:
      return {};
  }

  for (let i = 0; i < daysToRender; i++) {
    results[i] = rotation[i] || {
      participant: basePattern[i]?._id,
      dayOffset: i,
    };
  }

  // Flip the rotation if needed
  if (flip) {
    for (let i = 0; i < daysToRender; i++) {
      const block = results[i];
      if (block) {
        block.participant = block.participant === a._id ? b._id : a._id;
      }
    }
  }

  return results;
}
